const columnsCategory = [
  { name: 'name', align: 'left', label: 'Categorias', field: 'name', sortable: true },
  { name: 'description', align: 'left', label: 'Descrição', field: 'description', sortable: true },
  { name: 'actions', label: 'Ações', field: 'actions', sortable: false }
]

export {
  columnsCategory
}
